import { render } from "./SalesmanViewModal.vue?vue&type=template&id=3b969f93"
import script from "./SalesmanViewModal.vue?vue&type=script&lang=js"
export * from "./SalesmanViewModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__